import React, { Component } from 'react';
import { PrintModeContext } from './Slide';
interface PrintDeckProps {
  slides: {
    id: string;
    component: ComponentType;
  }[];
}
/**
 * A hidden, print-only rendering of every slide stacked vertically, each in a
 * fixed 16:9 page. Revealed only inside the browser's print / "Save as PDF"
 * flow via the `.print-deck` CSS rules in index.css. Each page becomes one
 * landscape PDF page.
 */
export function PrintDeck({
  slides
}: PrintDeckProps) {
  return <PrintModeContext.Provider value={true} data-id="element-72">
      <div className="print-deck" aria-hidden data-id="element-73">
        {slides.map(({
        id,
        component: SlideComponent
      }) => <div className="print-page" key={id} data-id="element-74">
            <SlideComponent data-id="element-75" />
          </div>)}
      </div>
    </PrintModeContext.Provider>;
}